/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Col_CityInputs */

const cs_projects_col_city = /** @type {(inputs: Projects_Col_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Město`)
};

const en_projects_col_city = /** @type {(inputs: Projects_Col_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Projects_Col_CityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_col_city = /** @type {((inputs?: Projects_Col_CityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Col_CityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_col_city(inputs)
	return cs_projects_col_city(inputs)
});